module.exports = __webpack_public_path__ + "static/media/left-quote-gray.f8be1e69.svg";